var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { mockData as calendarEvents } from '@web/lib/demo/data/calendarEvents';
import { mockData as chatEvents } from '@web/lib/demo/data/chatEvents';
import { mockData as documentEvents } from '@web/lib/demo/data/documentEvents';
import { mockData as meetingsEvents } from '@web/lib/demo/data/meetingEvents';
import { mockData as users } from '@web/lib/demo/data/users';
import { pickRandom } from '@web/lib/demo/utils';
import { ApplicationEnum } from '@workalizer/shared';
import { randomInt } from '@workalizer/shared/utils';
import { setHours, setMilliseconds, setMinutes, setSeconds } from 'date-fns';
export var userTimeline = function (input) {
    var EVENTS_PER_TYPE = 5;
    var demoUser = function (userId) {
        var _a;
        var user = (_a = users.find(function (item) { return item.id === userId; })) !== null && _a !== void 0 ? _a : users[0];
        return {
            id: user.id,
            email: user.email,
            name: user.name,
            avatar: user.avatar
        };
    };
    var getDateWithRandomTime = function (customHour) {
        var today = new Date(input.dateFrom);
        var hour = customHour !== null && customHour !== void 0 ? customHour : randomInt(8, 18);
        var minutes = randomInt(0, 59);
        return setMilliseconds(setSeconds(setMinutes(setHours(today, hour), minutes), 0), 0).toISOString();
    };
    var dataDocumentEvents = pickRandom(documentEvents, EVENTS_PER_TYPE).map(function (event) { return ({
        id: event.id,
        userId: input.userId,
        date: getDateWithRandomTime(),
        action: event.action,
        title: event.document.title,
        applicationName: ApplicationEnum.DRIVE,
        startDate: getDateWithRandomTime(14),
        endDate: getDateWithRandomTime(14),
        user: demoUser(input.userId),
        meetingsEvent: null,
        documentEvent: {
            action: event.action,
            document: {
                title: event.document.title
            }
        },
        calendarEvent: null,
        chatEvent: null,
        geminiEvent: null
    }); });
    var dataChatEvents = pickRandom(chatEvents, EVENTS_PER_TYPE).map(function (event) {
        var subUser = event.subUserId
            ? users.find(function (user) { return user.id === event.subUserId; })
            : null;
        return {
            id: event.id,
            userId: input.userId,
            date: getDateWithRandomTime(),
            action: event.action,
            title: event.room.title,
            applicationName: ApplicationEnum.CHAT,
            startDate: getDateWithRandomTime(16),
            endDate: getDateWithRandomTime(16),
            user: demoUser(input.userId),
            meetingsEvent: null,
            documentEvent: null,
            calendarEvent: null,
            geminiEvent: null,
            chatEvent: {
                subUser: subUser
                    ? {
                        id: subUser.id,
                        name: subUser.name,
                        email: subUser.email
                    }
                    : null,
                room: {
                    id: event.room.id,
                    slugId: event.room.slugId,
                    title: event.room.title,
                    type: event.room.type
                }
            }
        };
    });
    var dataMeetingsEvents = pickRandom(meetingsEvents, EVENTS_PER_TYPE).map(function (event) {
        var _a;
        var calendar = (_a = calendarEvents.find(function (calendar) { return calendar.id === event.meeting.calendarId; })) === null || _a === void 0 ? void 0 : _a.calendar;
        return {
            id: event.id,
            userId: input.userId,
            date: getDateWithRandomTime(),
            action: event.action,
            title: (calendar === null || calendar === void 0 ? void 0 : calendar.title) || '',
            applicationName: ApplicationEnum.MEET,
            startDate: getDateWithRandomTime(10),
            endDate: getDateWithRandomTime(10),
            user: demoUser(input.userId),
            meetingsEvent: {
                meeting: {
                    meetingGuests: event.meeting.meetingGuests.map(function (guest) {
                        var user = users.find(function (user) { return user.id === guest.userId; });
                        return {
                            user: {
                                email: (user === null || user === void 0 ? void 0 : user.email) || '',
                                name: (user === null || user === void 0 ? void 0 : user.name) || ''
                            }
                        };
                    }),
                    calendar: {
                        title: (calendar === null || calendar === void 0 ? void 0 : calendar.title) || ''
                    }
                }
            },
            documentEvent: null,
            calendarEvent: null,
            chatEvent: null,
            geminiEvent: null
        };
    });
    var dataCalendarEvents = pickRandom(calendarEvents, EVENTS_PER_TYPE).map(function (event) {
        var _a;
        var calendar = (_a = calendarEvents.find(function (calendar) { return calendar.id === event.calendarId; })) === null || _a === void 0 ? void 0 : _a.calendar;
        return {
            id: event.id,
            userId: input.userId,
            date: getDateWithRandomTime(),
            action: event.action,
            title: (calendar === null || calendar === void 0 ? void 0 : calendar.title) || '',
            applicationName: ApplicationEnum.CALENDAR,
            startDate: getDateWithRandomTime(9),
            endDate: getDateWithRandomTime(9),
            user: demoUser(input.userId),
            meetingsEvent: null,
            documentEvent: null,
            calendarEvent: {
                calendar: {
                    title: (calendar === null || calendar === void 0 ? void 0 : calendar.title) || ''
                }
            },
            chatEvent: null,
            geminiEvent: null
        };
    });
    return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], dataDocumentEvents, true), dataChatEvents, true), dataMeetingsEvents, true), dataCalendarEvents, true);
};
